import { CliError } from "@/lib/cli/cli-error";
import { DEFAULT_TIMEOUT_MS } from "@/lib/api/api-constants";
export function resolveTimeout(override?: number): number {
  if (override !== undefined) {
    return override;
  }
  const raw = process.env.HEPHA_TIMEOUT_MS?.trim();
  if (!raw) {
    return DEFAULT_TIMEOUT_MS;
  }
  const parsed = Number(raw);
  if (!Number.isFinite(parsed) || parsed <= 0) {
    throw new CliError(
      `HEPHA_TIMEOUT_MS expects a positive number of milliseconds, got "${raw}".`,
      2,
    );
  }
  return parsed;
}
